import React, { useEffect, useState } from "react";
import { Shell, Section } from "@/components/loomi/Layout";
import { api } from "@/lib/api";
import ChangePasswordCard from "@/components/loomi/ChangePasswordCard";
import { ADMIN_NAV } from "./admin/AdminDashboard";
import { PM_NAV } from "./pm/PmDashboard";
import { CLIENT_NAV } from "./client/ClientDashboard";

/**
 * Shared profile page for admin / pm / client portals.
 * Panelist has its own richer profile at /panel/profile (demographics + change password).
 */
const CFG = {
  admin:  { nav: ADMIN_NAV,  label: "Admin",  testPrefix: "admin-profile" },
  pm:     { nav: PM_NAV,     label: "PM",     testPrefix: "pm-profile" },
  client: { nav: CLIENT_NAV, label: "Client", testPrefix: "client-profile" },
};

export default function OperatorProfile({ role }) {
  const cfg = CFG[role];
  const [me, setMe] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/auth/me");
      setMe(data);
    })();
  }, []);

  const isGoogleOnly = me?.auth_provider === "google";

  return (
    <Shell title="Your profile" portalLabel={cfg.label} nav={cfg.nav}>
      <div className="grid md:grid-cols-3 gap-6">
        <Section title="Account" testId={`${cfg.testPrefix}-account`}>
          <div className="space-y-3 text-sm">
            <Row k="Name" v={me?.name} />
            <Row k="Email" v={me?.email} mono />
            <Row k="Role" v={me?.role?.toUpperCase()} />
            <Row k="Status" v={me?.status} />
            <Row k="2FA" v={me?.totp_enabled ? "Enabled" : "Disabled"} />
            <Row k="Joined" v={me ? new Date(me.created_at).toLocaleDateString() : "—"} />
          </div>
        </Section>
        <div className="md:col-span-2">
          <ChangePasswordCard testPrefix={cfg.testPrefix} isGoogleOnly={isGoogleOnly} />
        </div>
      </div>
    </Shell>
  );
}

function Row({ k, v, mono }) {
  return (
    <div className="flex items-start justify-between gap-4 border-b border-white/5 pb-2">
      <div className="text-[10px] uppercase tracking-widest text-mute">{k}</div>
      <div className={`text-right ${mono ? "font-mono text-xs" : ""}`}>{v ?? "—"}</div>
    </div>
  );
}
